import { NOT_AVAILABLE, TransportMode } from '../../../../common/constants';
import { mapNullToNotAvailableValue } from '../../../../common/utils';
import { LocalDate } from '../../../models';
import { StatusAcceptanceType } from '../../../constants';
import { TransportationTrackingDates, TransportationTrackingParty } from '../../../../ui-kit';
import { LatestNotification } from '../../monitoring/models';

export interface LoadIdentifier {
  loadNumber: string;
}

export interface LoadStatus {
  assignedDateTime: LocalDate;
  acceptanceType: StatusAcceptanceType;
  statusCode: string;
  current: boolean;
  statusDescription: string;
  address: string;
  hide?: boolean;

  latestNotification: LatestNotification;
}

export class LoadOverview {
  billOfLading = NOT_AVAILABLE;
  driverContact = NOT_AVAILABLE;
  driverName = NOT_AVAILABLE;
  flightNumber = NOT_AVAILABLE;
  freightForwarderNumber = NOT_AVAILABLE;
  houseAirWaybill = NOT_AVAILABLE;
  houseBillOfLading = NOT_AVAILABLE;
  inTime = null;
  istarNumber = NOT_AVAILABLE;
  loadNumber = NOT_AVAILABLE;
  loadStatuses: LoadStatus[];
  masterAirWaybill = NOT_AVAILABLE;
  origin = NOT_AVAILABLE;
  plannedArrivalDateTime = NOT_AVAILABLE;
  speedUpInformation: string;
  trailerPlates = [];
  transportMode: TransportMode;
  truckPlate = NOT_AVAILABLE;
  vesselName = NOT_AVAILABLE;
  carrierId = NOT_AVAILABLE;
  carrierName = NOT_AVAILABLE;
  latestNotification: LatestNotification;
  loadRemarks: string;
  dates: TransportationTrackingDates;
  delivery: TransportationTrackingParty;
  pickup: TransportationTrackingParty;
  isCancelled: boolean;
  carriageCondition: string;
  serviceRequirement: string;
  containerIds: string[];

  constructor(params?: LoadOverview) {
    if (params) {
      Object.assign(this, mapNullToNotAvailableValue(params));
    }
  }
}
